import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { noop } from '@src/utils/common-util';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';

class BaseModalStore extends BaseStore {
  // 是否展示
  @observable isActive;
  // 是否展开弹窗
  @observable isOpen;

  @observable onClose = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 清除body添加的样式
   */
  clearStyle() {
    const Element = document.body;
    Element.removeAttribute('style');
  }

  /**
   * 点击关闭按钮
   * 如果需要自定义关闭事件, 则可以重写
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.clearStyle();
  };

  use() {
    // super.use();
    useMount(() => {
      this.isActive = true;
    });

    useEffect(
      () => {
        if (this.isActive) {
          this.isOpen = this.isActive;
        } else {
          this.onClose();
        }
      },
      [this.isActive]
    );
  }
}

export default BaseModalStore;
